import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, StaffAssignmentFilter, RecurrenceRegister } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, RecurrencePatterns, RecurrencePatterns_End, RECURRENCE_ROOMSTATUS } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, Staff_Search_Assigment } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { CallDescriptionLookup, CallCategoryLookup, LocationLookup } from '../../Models/GlobalEntities';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbTimeStruct, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../Services/UserService';
import * as moment from "moment";
import { RecurrenceConsoleService } from '../../Services/RecurrenceConsoleService';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'RecurrenceUpdate',
    templateUrl: './RecurrenceUpdate.html'
})

export class RecurrenceUpdate extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    Model: RecurrenceRegister;
    ModalRef: NgbModalRef;
    Weekdays: string[];
    Days: number[] = [];
    enumRP = RecurrencePatterns;
    enumRP_End = RecurrencePatterns_End;
    selectedWeekdays: any = {};
    selectedMonthDays: any = {};
    OccurrenceCount: number = 0;

    @Output() RecurrenceAdded: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, private complainService: ComplainService, private modalService: NgbModal, public recurrenceConsoleService: RecurrenceConsoleService) {
        super(translate, toastr, route, router, masterService);

        this.Weekdays = moment.weekdays();
        this.Weekdays.map(val => {
            this.selectedWeekdays[val] = false;
        })

        for (let i = 1; i <= 31; i++) {
            this.Days.push(i);
            this.selectedMonthDays[i] = false;
        }

        this.Days.push(-1);
        this.selectedMonthDays['-1'] = false;

        this.Model = new RecurrenceRegister();
    }

    ngOnInit(): void {
    }

    Open(data: any): void {
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg',
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.OccurrenceCount = 0;
        this.SetModelDefaults();

        if (data.RecurrencePattern && data.RecurrencePattern != 1 && data.RecurrencePattern != 2) {
            if (data.Dow) {
                var arr = data.Dow.split(',')

                for (var i = 0; i < arr.length; i++) {
                    if (!isNaN(arr[i]))
                        this.selectedMonthDays[arr[i]] = true;
                    else
                        this.selectedWeekdays[arr[i]] = true;
                }
            }
        }

        if (data.RegisterAtEndOfMonth)
            this.selectedMonthDays[-1] = true;

        _.assignIn(this.Model, data);

        this.Model.Remarks = this.Model.Remarks == null ? "Scheduled Call:" : "Scheduled Call:" + this.Model.Remarks;

        if (data.RecurrenceFrequency) {
            this.Model.RecurrenceFrequency = data.RecurrenceFrequency;
        }

        if (data.MaxRecurrence) {
            this.Model.MaxRecurrence = data.MaxRecurrence;
        }

        if (this.Model.IsGuestCall) {
            this.Model.RoomStatus = RECURRENCE_ROOMSTATUS.ROOMSTATUS_OCCUPIED;
            if (data.RequestedById) {
                this.Model.RequestedByGuestId = data.RequestedById;
            }
        }
        if (this.Model.IsGuestCall && data.ReportedById) {
            this.Model.RequestedByGuestId = data.ReportedById;
        }
        else if (!this.Model.IsGuestCall && data.ReportedById) {
            this.Model.RequestedByStaffId = data.ReportedById;
        }

        if (this.Model.StartDateTime) {
            this.Model.StartDateTime = new Date(this.Model.StartDateTime);
        }

        if (this.Model.EndDateTime) {
            this.Model.EndDateTime = new Date(this.Model.EndDateTime);
        }

        if (data.OccurrenceCount) {
            this.OccurrenceCount = _.assign(data.OccurrenceCount);
        }
    }

    Transform_Weekday(): void {
        if (this.Model.RecurrencePattern != RecurrencePatterns.Weekly)
            return;

        let obj = this.selectedWeekdays;

        let arr: string[] = [];

        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                var val = obj[prop];
                if (val) {
                    arr.push(prop);
                }
            }
        }
        this.Model.RecurrenceFrequency = 1;
        this.Model.Dow = arr.join(',');
    }

    Transform_MonthDays(): void {
        if (this.Model.RecurrencePattern != RecurrencePatterns.Monthly) {
            this.Model.RegisteredAtEndOfMonth = false;
            return;
        }

        let obj = this.selectedMonthDays;

        let arr: string[] = [];

        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                var val = obj[prop];
                if (prop == '-1') {
                    if (val) {
                        this.Model.RegisteredAtEndOfMonth = true;
                    }
                    else {
                        this.Model.RegisteredAtEndOfMonth = false;
                    }
                }
                else {
                    if (val) {
                        arr.push(prop);
                    }
                }
            }
        }

        this.Model.Dow = arr.join(',');
    }

    Validate(): void {
        this.ClearErrors();

        let m = this.Model;
        let cDate = new Date();

        if (m.StartDateTime == null) {
            this.AddError('ERR.ENTER_START_DATE');
        }
        else {
            if (m.RecurrenceId == null && m.StartDateTime <= cDate)
                this.AddError('ERR.ERR_START_DATE_GREATER_THAN_TODAY');
        }

        switch (m.RecurrencePattern) {
            case RecurrencePatterns.Daily:
                if (m.RecurrenceFrequency == null || m.RecurrenceFrequency <= 0) {
                    this.AddError('ERR.ERR_ENTER_DAILY_FREQ_VALUE');
                }
                break;
            case RecurrencePatterns.Hourly:
                if (m.RecurrenceFrequency == null || m.RecurrenceFrequency <= 0) {
                    this.AddError('ERR.ERR_ENTER_HOURLY_FREQ_VALUE');
                }
                break;
            case RecurrencePatterns.Weekly:
                if (m.Dow == null || m.Dow.length <= 0) {
                    this.AddError('ERR.ERR_SELECT_ATLEAST_1_WEEKDAY');
                }
                break;
            case RecurrencePatterns.Monthly:
                if (m.RecurrenceFrequency == null || m.RecurrenceFrequency <= 0) {
                    this.AddError('ERR.ERR_INVALID_FREQUENCY');
                }

                if ((m.Dow == null || m.Dow.length <= 0) && m.RegisteredAtEndOfMonth == false) {
                    this.AddError('ERR.ERR_SELECT_ATLEASE_1_DAY');
                }
                break;
        }

        switch (m.EndPattern) {
            case RecurrencePatterns_End.EndBy:
                if (m.EndDateTime == null) {
                    this.AddError('ERR.ERR_ENTER_DATE_TIME');
                }
                else {
                    if (m.RecurrenceId == null && m.EndDateTime <= cDate) {
                        this.AddError('ERR.ERR_END_DATE_GREATER_THAN_CURRENT_DATE');
                    }

                    if (m.StartDateTime != null && m.EndDateTime != null && m.StartDateTime >= m.EndDateTime) {
                        this.AddError('ERR.ERR_END_DATE_NOT_LESS_EQUALTO_START_DATE');
                    }
                }
                break;
            case RecurrencePatterns_End.EndsAfter:
                if (m.MaxRecurrence == null || m.MaxRecurrence <= 0) {
                    this.AddError('ERR.ERR_ENTER_MAX_OCURRENCES');
                }
                break;
            case RecurrencePatterns_End.NoEndDate:
                if (m.IsGuestCall && m.RequestedByGuestId == null) {
                    this.AddError('ERR.ERR_SELECT_GUEST');
                }
                break;
            //case RecurrencePatterns_End.OnCheckout:

        }
    }

    onSubmit(): void {
        if (this.IsSubmitting)
            return;

        this.SubmitStart();

        this.Transform_Weekday();
        this.Transform_MonthDays();

        this.Validate();

        if (this.HasErrors) {
            this.SubmitEnd();
            return;
        }

        if (this.Model.EndPattern != this.enumRP_End.EndsAfter) {
            this.Model.MaxRecurrence = 0;
        }

        if (this.Model.IsGuestCall == false) {
           this.Model.TritonReservationId = null;
        }
        this.recurrenceConsoleService.Recurrence_Save(this.Model).then(data => {
            this.SubmitEnd();
            this.FromBaseResponse(data);
            if (this.HasErrors) {
              return;
            }
            this.Model = new RecurrenceRegister();
            this.RecurrenceAdded.emit(true);
            this.GetMultilingualToast('TS.TS_RECURRENCE_SAVE_SUCCESS', 'success');
            this.ModalRef.close();
        });
    }


    SetModelDefaults(): void {
        this.ClearErrors();
        this.Model.MaxRecurrence = 0;
        this.Model.RecurrencePattern = RecurrencePatterns.Hourly;
        this.Model.EndPattern = RecurrencePatterns_End.EndBy;
        this.Model.RecurrenceFrequency = 1;
        this.Model.RoomStatus = RECURRENCE_ROOMSTATUS.ROOMSTATUS_BOTH;
        this.Model.StartDateTime = null;
        this.Model.EndDateTime = null;

        this.Weekdays = moment.weekdays();
        this.Weekdays.map(val => {
            this.selectedWeekdays[val] = false;
        })

        this.selectedMonthDays[-1] = false;

        for (let i = 1; i <= 31; i++) {
            this.selectedMonthDays[i] = false;
        }
    }
}
